;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);

	$doc.ready(function() {
		/**
		 * Hides an element and removes active classes from a trigger element and the `html` tag
		 *
		 * @param  {Object} event                    Event data
		 *
		 * @return {Void}
		 */

		function hideElementOnDocumentClick(event, clickHandler) {
			var $target = $(event.target);
			var $wrapper = $('.wrapper');
			var $html = $('html');


			var elementClass = clickHandler.elementClass;
			var triggerClass = clickHandler.triggerClass;
			var elementVisibleClass = clickHandler.elementVisibleClass;
			var triggerActiveClass = clickHandler.triggerActiveClass;
			var globalVisibleClass = clickHandler.globalVisibleClass;

			if (
				!$target.hasClass(elementClass) &&
				!$target.parents('.' + elementClass).length &&
				!$target.hasClass(triggerClass) &&
				!$target.parents('.' + triggerClass).length
				) {
					$('.' + elementClass).removeClass(elementVisibleClass);
					$('.' + triggerClass).removeClass(triggerActiveClass);

					$wrapper.removeClass(globalVisibleClass);
					$html.removeClass(globalVisibleClass);
				}
		}

		/**
		 * @param  {String} elementClass             Selector for the element to hide
		 * @param  {String} triggerClass             Selector for the trigger
		 * @param  {String} elementVisibleClass      Classname to remove from the element
		 * @param  {String} triggerActiveClass       Classname to remove from the trigger
		 * @param  {String} globalVisibleClass       Classname to remove from the `html` tag
		 */
		var clickHandlers = [
			{
				elementClass: 'search .field',
				triggerClass: 'search',
				elementVisibleClass: 'input-visible',
				triggerActiveClass: '',
				globalVisibleClass: ''
			}
		];

		$doc.on('click touchend', function(event) {
			clickHandlers.forEach(function(clickHandler) {
				hideElementOnDocumentClick(event, clickHandler);
			});
		});

		//Rsponsive dropdown
		$('.nav').on('click', '.menu-item-has-children > a', function(event) {
			if ($win.width() < 768) {
        if (!$(this).parent().hasClass('is-expanded')) {
					$(this).siblings('ul').stop().slideToggle().parent().toggleClass('is-expanded');
					event.preventDefault();
				}
			}
		});

		$('.btn_buy_now').on('click', function(event) {
			event.preventDefault();
			$('#buy_now_trigger').trigger('click');
		})

		// Check for Firefox and handle anchor scrollback on initial load of URL of with fragment
		// Firefox appears to always jump to anchor points
		if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {

			// // case when going to Buy Now tab from collection page
			// if (location.hash.indexOf('buy-now') >= 0) {
			// 	//console.log("LOCATION.HASH ---------> " + location.hash);
			// 	// cascading timers as move to anchor point in FF appears to occur independent of on window or page loads
			// 	setTimeout(function() {
			// 	  window.scrollTo(0, 0);
			// 	}, 500);
			// 	setTimeout(function() {
			// 	  window.scrollTo(0, 0);
			// 	}, 1000);	
			// }

			// // case where page is reached directly via URL
			// // stop jump to anchor point
			// if(document.referrer.toLowerCase().indexOf('dart') == -1) {
				
			// 	// cascading timers as move to anchor point in FF appears to occur independent of on window or page loads
			// 	setTimeout(function() {
			// 	  window.scrollTo(0, 0);
			// 	}, 500);
			// 	setTimeout(function() {
			// 	  window.scrollTo(0, 0);
			// 	}, 1000);							

			// 	// following didn't move FF back to top
			// 	// if(history.pushState) {
			// 	//     history.pushState(null, null, location.hash);
			// 	//     console.log("---> in history.pushState");
			// 	// }

			// 	// $(window).load(function() {
			// 	//     // page is fully loaded, including all frames, objects and images
			// 	//     window.scrollTo(0, 0);
			// 	// });

			// }

	  		if (window.performance) {
			    if (performance.navigation.type == 1) {
			    	window.scrollTo(0, 0);
					//console.log( "*** This page is reloaded in FIREFOX" );
				}
			}
		}

		//Init Slider Logos
		$('.slider-intro .owl-carousel').owlCarousel({
			autoplay: false,
			loop: false,
			margin: 0,
			mouseDrag: false,
			touchDrag: false,
			startPosition: 2,
			items: 1,
			nav: false,
			navText: ''
			// smartSpeed: 1800,
		});

		//Show search field
		$('.search__btn').on('click', function(event){
			var input = $(this).prev();

			if( !input.hasClass('input-visible') ) {
				event.preventDefault();

				input.addClass('input-visible');
			}
		});

		//Check for dropdown
		$('.nav li').each(function() {
			var $this = $(this);
			var hasDropdown = $this.find('> .nav-menu').length;

			if (hasDropdown) {
				$this.addClass('has-dropdown');
			}
		});

		//Responsive navigation
		$('.nav-button').on('click', function(event) {
			event.preventDefault();

			$('.nav').toggleClass('is-visible');
			$(this).toggleClass('opened');
		});


		// Login Page
		if ($('.template-login').length > 0) {
			$('.link-forgot-password').on('click', function() {
				$('#btn-form-recover-password').attr('checked', 'checked').trigger('change').siblings('input').removeAttr('checked')
			})

			$('input').on('change', function() {
				$('input:checked').next('form').show().siblings().hide()
			})
		}

		// Collection Filter
		$('.bar__inner .select__inner').on('change', function(event) {
			window.location = $(this).val();
		});

		//Init Tabs
		var activeTabClass = 'current';

		var tabId = window.location.hash;
		if ( tabId != '' && tabId != '#' ) {
            tabId = tabId.split(':')[0]; // for referencing ids within a specific tab
			$(tabId).addClass('current').siblings().removeClass('current');
			$('.tabs__nav a[href="'+ tabId +'"]').parent().addClass('current').siblings().removeClass('current');
		}

		$('.template-product .tabs__nav a:not(.external_link), .template-alt .tabs__nav a:not(.external_link)').on('click', function(event) {
			event.preventDefault();
			
      $('.tabs__body').show();
      $('#buy_now').hide();

			var $tabLink = $(this);
			var $targetTab = $($tabLink.attr('href'));

			location.hash = $(this).attr('href').split('#')[1];

			$tabLink
				.parent()
				.add($targetTab)
				.addClass(activeTabClass)
					.siblings()
					.removeClass(activeTabClass);
		});

		$('body').on('click', '.tabs__body a', function(event){
			var href = $(this).attr('href');
			var hashSplitted = href.split('#');
			var $tabsNav = $('.tabs__nav a');
			var hasTab = false;
			var hash = '';

			//event.preventDefault();
			if (hashSplitted.length > 1) {
				hash = hashSplitted[1];
			}

			$tabsNav.each(function() {
				var link = $(this).attr('href');
				link = link.substring(1);

				if (link == hash) {
					hasTab = true;
				}
			})

			if(hasTab) {
				var $tab = $('.tabs__nav').find('a[href="#' + hash + '"]');
				$tab.trigger('click');
			}
		})

        $('body').on('click', '.tabs__nav a:not(.external_link)', function(event) {
            if($('body').attr('class').includes('branding'))
            	return;
          
          	var $tabLink = $(this);
				$tabLink.
					closest('li')
					.addClass(activeTabClass)
						.siblings()
						.removeClass(activeTabClass);


			if ( $('.template-product').length == 0 && $('.template-alt').length == 0) {
				event.preventDefault();

				$.ajax({
					url: $tabLink.attr('href'),
				})
				.done(function(data) {
					var $container = $('.section__body');

					$container.parent().html($(data).find('.section__body'));
                  	window.history.pushState(null, null, $tabLink.attr('href')); //08212018 - for page.information templates changes URL in address bar
				})
			}
		});

		$('body').on('change', '.tabs__select-outer select', function (event) {

			var $selectedOption = $(this).find('option:selected');
				
			if ($selectedOption.attr('data-link')) {
				window.open($selectedOption.attr('data-link'), '_blank');
				//window.location.href = $selectedOption.attr('data-link');
			} else {
				window.history.pushState(null, null, $selectedOption.val()); //08312018 - for page.information templates changes URL in address bar
				if ($(this).hasClass('has_ajax')) {
					var pageLink = $selectedOption.val();
					$.ajax({
						url: pageLink,
					})
					.done(function(data) {
						var $container = $('.section__body');

						$container.parent().html($(data).find('.section__body'));
					})
				} else {
					$($selectedOption.val()).addClass('current').siblings().removeClass('current');
				}
			}
		})

    $('.form__body input[type="radio"], .form__body select, .radio_support').on('change', function() {
      
      var productData = '';
      
      var data = $(this).closest('form').find('input[type="radio"]:checked, select#field-license').each(function() {
        var $item = $(this);
        productData += '[data-'+  $item.attr('name') +'="'+ $item.val() +'"]';
      });

      
      //hide premium support option unless a subscription type is selected
      if(this.checked && !$(this).hasClass("radio_support")) {
      	//console.log($(this).val() + " is checked");
      	if($(this).val() == 'subscription' || $(this).val() == 'single' || $(this).val() == '4-pack' || $(this).val() == '8-pack') {
      		$('#premium-support').show();
      	} else {
      		$('#premium-support').hide();   		
      	}
      }
      // if($(this.val == 'subscription') && $(this.checked)){
      // 	$('#premium-support').removeClass("hidden");
      // 	console.log("found ==> " + $(this).val());
      // }
      // if($(this.val == 'license') && $(this.checked)){
      // 	$('#premium-support').addClass("hidden");
      // 	console.log("not found ==> " + $(this).val());
      // }

      var price = $('.product--original').find('option' + productData ).prop('selected', true).data('price');
      //var compare_at_price = $('.product--original').find('option' + productData ).prop('selected', true).data('compare_at_price');
      var discount = $('.product--original').find('option' + productData ).prop('selected', true).data('discount');

      if ($('.radio_support').is(':checked') ) {
      	var orig_price = price;
      		// console.log("----> " + $('input[name=option-1]:checked').val());
      		// only add support price if it's a subscription type of product
      		if($('input[name=option-1]:checked').val() == 'subscription' || $('input[name=option-1]:checked').val() == 'single' || $('input[name=option-1]:checked').val() == '4-pack' || $('input[name=option-1]:checked').val() == '8-pack') {
		      	var support_price = $('.support_price').data('support-price');
		      	price = price + support_price;
		     } else {
		     	price = orig_price;
		     	$('.radio_support').prop('checked', false);
		     }
      }

      $('.variant_price').text("$" + (price/100) + ".00");
     
      $('.form__discount').text("$" + (discount/100) + ".00 discount");
     
    });

		// This number is magically chosen
		var navItemsSize = 13;

		function splitList($nav, size) {
			var temp = [];
			var markup = [];
			var $items = $nav.find('li');

			$items.unwrap();

			for ( var i = 0, j = $items.length; i < j; i += size ) {
				temp.push([].slice.call($items, i, i + size));
			}

			temp.forEach(function (item) {
				var html = '<ul>';

				item.forEach(function (el) {
					html += $.trim(el.outerHTML);
				});

				html += '</ul>';

				markup.push(html);
			});

			$nav.html(markup.concat());
		}

		function equalizeWidth($items, $parent, breakpoint) {
			$items.each(function() {
				var $item = $(this);

				if ( $win.width() < breakpoint ) {
					$item.removeAttr('style');
				} else {
					$item.innerWidth($parent.width() / $items.length);
				}
			});
		}

		function equalizeNavsWidth(breakpoint) {
			$('.nav-menu').each(function() {
				equalizeWidth($(this).find('ul'), $(this), breakpoint);
			});
		}

		$('.js-split').each(function() {
			splitList($(this), navItemsSize);
		});

		equalizeNavsWidth(1024);

		$win.on('resize', function() {
			equalizeNavsWidth(1024);
		});

		$doc.on('click', '.more_content .show_more_content, .more_content .hide_more_content', function(event) {
			event.preventDefault();
			var $this = $(this);

			$this.closest('.more_content').find('.show_more_content').toggleClass('hidden');
			$this.closest('.more_content').find('.content').toggleClass('hidden');
			$this.closest('.more_content').find('.hide_more_content').toggleClass('hidden');
		})

		// rotate through reviews
		function rotateReviews () {

			// init reviews hiding all except first
			var count = 0;
			var firstEl;

			$('#shopify-product-reviews').css("visibility", "visible");

			$('div.spr-review').each (function (i) {
				if( i == 0) {
					$(this).addClass('active');
					firstEl = $(this);
				} else {
					$(this).addClass('hidden');
				}
				count++;
			});

			count--;

			// loop through at a given interval hiding and showing reviews
			setInterval(function() {

				$('div.spr-review').each (function (i) {

					// console.log("current index: " + i);
					// console.log("is this active: " + $(this).hasClass('active'));

					if ( $(this).hasClass('active') == true && i < count ) {
						$(this).removeClass('active').addClass('hidden');
						$(this).next().removeClass('hidden').addClass('active');
						return false;
					}
					if ( $(this).hasClass('active') == true && i == count ) {
						$(this).removeClass('active').addClass('hidden');
						firstEl.removeClass('hidden').addClass('active');
						return false;
					}

				});


			}, 7000);

			//console.log ("number of reviews: " + count);

		}

		setTimeout(rotateReviews, 2000);

	});
})(jQuery, window, document);

$(function(){

	// check if a subscription is the checked radio on inital page load
	$('input:radio').each(function() {
		
	  $(this).trigger("click"); //needed for products with licensing and subscriptions radios, ensures on initial load proper variant is ready for addition to cart

	  if($(this).is(':checked')) {
      	//console.log($(this).val() + " is checked");
      	if($(this).val() == 'subscription' || $(this).val() == 'single' || $(this).val() == '4-pack' || $(this).val() == '8-pack') {
      		$('#premium-support').show();
      	} else {
      		$('#premium-support').hide();
      	}
	  } 
	});

  // Bind the event.
  $(window).hashchange( function(){

  	//console.log ("RECORDED A HASHCHANGE");

    var tabIdchange = location.hash;
    var subtag = (tabIdchange.split(':').length > 1);
    tabIdchange = tabIdchange.split(':')[0];
    
    substring = "noscrollback";
    if ( tabIdchange != '' && tabIdchange != '#' && tabIdchange.indexOf(substring) == -1) {
          $(tabIdchange).addClass('current').siblings().removeClass('current');
          $('.tabs__nav a[href="'+ tabIdchange +'"]').parent().addClass('current').siblings().removeClass('current'); 

          if(!subtag) {
            window.scrollTo(0, 0);
            //Firefox will not properly scroll to the top if it's an in page anchor link, it jumps to that link.  This is a workaround
            setTimeout(function() {
              window.scrollTo(0, 0);
            }, 1);
          }
    } else {
        $('#tab1').addClass('current').siblings().removeClass('current');
        $('.tabs__nav a[href="tab1"]').parent().addClass('current').siblings().removeClass('current');		
    }
  });

	// prevent double click move to anchor seen in Firefox 
	$('.tabs .tabs__nav a').on('click', function(event) {	
		var href = $(this).attr('href');
		var hashSplitted = href.split('#');
		var hash = '';

		if (hashSplitted.length > 1) {
			hash = "#" + hashSplitted[1];
		}

		if ( hash == window.location.hash ){
			//console.log("Hash matches");
			scrollTo(0, 0);
		}
		//console.log(">> hash: " + hash);
		//console.log(">> window.location.hash: " + window.location.hash);

	});  

  // Trigger the event (useful on page load).
  $(window).hashchange();
});
